import { render, staticRenderFns } from "./ordercard.vue?vue&type=template&id=437da822&scoped=true&"
import script from "./ordercard.vue?vue&type=script&lang=js&"
export * from "./ordercard.vue?vue&type=script&lang=js&"
import style0 from "./ordercard.vue?vue&type=style&index=0&id=437da822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437da822",
  null
  
)

export default component.exports